"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunitySearchResultItemDto = instanceOfOrientationOpportunitySearchResultItemDto;
exports.OrientationOpportunitySearchResultItemDtoFromJSON = OrientationOpportunitySearchResultItemDtoFromJSON;
exports.OrientationOpportunitySearchResultItemDtoFromJSONTyped = OrientationOpportunitySearchResultItemDtoFromJSONTyped;
exports.OrientationOpportunitySearchResultItemDtoToJSON = OrientationOpportunitySearchResultItemDtoToJSON;
exports.OrientationOpportunitySearchResultItemDtoToJSONTyped = OrientationOpportunitySearchResultItemDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const StipendDto_1 = require("./StipendDto");
const OrientationOpportunitySessionDto_1 = require("./OrientationOpportunitySessionDto");
const OrientationOpportunityStatus_1 = require("./OrientationOpportunityStatus");
const FacilityDto_1 = require("./FacilityDto");
const OrientationOpportunityRequestAbbrDto_1 = require("./OrientationOpportunityRequestAbbrDto");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the OrientationOpportunitySearchResultItemDto interface.
 */
function instanceOfOrientationOpportunitySearchResultItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('payRate' in value) || value['payRate'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('orientationSessions' in value) || value['orientationSessions'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('isQualifiedForStipend' in value) || value['isQualifiedForStipend'] === undefined)
        return false;
    return true;
}
function OrientationOpportunitySearchResultItemDtoFromJSON(json) {
    return OrientationOpportunitySearchResultItemDtoFromJSONTyped(json, false);
}
function OrientationOpportunitySearchResultItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'description': json['description'] == null ? undefined : json['description'],
        'payRate': json['payRate'],
        'totalRate': json['totalRate'],
        'orientationSessions': (json['orientationSessions'].map(OrientationOpportunitySessionDto_1.OrientationOpportunitySessionDtoFromJSON)),
        'facility': (0, FacilityDto_1.FacilityDtoFromJSON)(json['facility']),
        'status': (0, OrientationOpportunityStatus_1.OrientationOpportunityStatusFromJSON)(json['status']),
        'specialtyCode': json['specialtyCode'],
        'specialty': json['specialty'] == null ? undefined : (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)(json['specialty']),
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendDto_1.StipendDtoFromJSON)),
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'startTime': (new Date(json['startTime'])),
        'isQualifiedForStipend': json['isQualifiedForStipend'],
        'request': json['request'] == null ? undefined : (0, OrientationOpportunityRequestAbbrDto_1.OrientationOpportunityRequestAbbrDtoFromJSON)(json['request']),
        'distance': json['distance'] == null ? undefined : json['distance'],
    };
}
function OrientationOpportunitySearchResultItemDtoToJSON(json) {
    return OrientationOpportunitySearchResultItemDtoToJSONTyped(json, false);
}
function OrientationOpportunitySearchResultItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'description': value['description'],
        'payRate': value['payRate'],
        'totalRate': value['totalRate'],
        'orientationSessions': (value['orientationSessions'].map(OrientationOpportunitySessionDto_1.OrientationOpportunitySessionDtoToJSON)),
        'facility': (0, FacilityDto_1.FacilityDtoToJSON)(value['facility']),
        'status': (0, OrientationOpportunityStatus_1.OrientationOpportunityStatusToJSON)(value['status']),
        'specialtyCode': value['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)(value['specialty']),
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendDto_1.StipendDtoToJSON)),
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'startTime': ((value['startTime']).toISOString()),
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'request': (0, OrientationOpportunityRequestAbbrDto_1.OrientationOpportunityRequestAbbrDtoToJSON)(value['request']),
        'distance': value['distance'],
    };
}
//# sourceMappingURL=OrientationOpportunitySearchResultItemDto.js.map